import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { ValidationHelper } from "@/Common/Helpers/ValidationHelper";
import { ContactPointType } from "@/Common/Models/Contacts/Enums/ContactPointType";
import { ContactPoint } from "./ContactPoint";
import { Email } from "./Email";

class EmailContact {
    public Id: string;
    public Address: string;
    public IsOkToContact: boolean;
    public IsPreferred: boolean;
    public IsVerified: boolean;
    public VerificationCode: string;
    public ContactId: string;
    public ContactPointTypeLookupId: string;
    public NotificationsEnabled: boolean;

    /**
     * The reference ID used for client-side rendering
    */
    public renderId: string;

    constructor() {
        this.Id = GuidHelper.Empty(); // ContactPointId
        this.Address = "";
        this.IsOkToContact = false;
        this.ContactPointTypeLookupId = cacheStore.GetPhoneContactPointTypeLookupTuples()[0][0].LookupID;
        this.IsPreferred = false;
        this.IsVerified = false;
        this.VerificationCode = "";
        this.renderId = sessionStore.newId().toString();
    }

    public isValid(isEmptyValid: boolean = true): boolean {
        return EmailContact.validateEmail(this.Address, isEmptyValid) && !isGuidNullOrUndefinedOrEmpty(this.ContactPointTypeLookupId);
    }

    public static newEmail(): EmailContact {
        let email = new EmailContact();
        email.ContactPointTypeLookupId = cacheStore.getLookupByContactPointType(ContactPointType.Personal).LookupID;
        email.Address = "";
        email.IsVerified = false;
        email.VerificationCode = "";

        return email;
    }

    public static isEmpty(email: EmailContact): boolean {
        return (email.Address == null || email.Address.length == 0);
    }

    public static getFormattedEmail(emails: EmailContact[], position: number = 0): string {
        var emailtext = "";
        if (emails != null && emails.length > position) {
            if (emails[position].Address && emails[position].Address.length > 0) {
                emailtext = emails[position].Address;
            }
        }
        return emailtext;
    }

    public static validateEmail(value: string, isEmptyValid: boolean = true): boolean {
        if (isEmptyValid && (value == null || value.length == 0))
            return true;

        return ValidationHelper.isExactMatch(value, ValidationHelper.emailRegex);
    }

    public static toEmailContact(email: Email, contactPoint: ContactPoint): EmailContact {
        let emailContact = EmailContact.newEmail();

        emailContact.Id = contactPoint.Id;
        emailContact.ContactId = contactPoint.ContactId;
        emailContact.ContactPointTypeLookupId = contactPoint.ContactPointTypeLookupId;
        emailContact.Address = email.Address;
        emailContact.IsVerified = email.IsVerified;
        emailContact.IsOkToContact = email.IsOkToContact;
        emailContact.IsPreferred = email.IsPreferred;
        emailContact.NotificationsEnabled = email.NotificationsEnabled;

        return emailContact;
    }
}

export { EmailContact };
